// Messagerie (H8-01) : schémas des entrées des routes /messagerie et du flux /evenements.
import { z } from 'zod';
import { schemaDateHeure } from './commun';

export const TYPES_CONVERSATION = ['interne', 'usager', 'institutionnelle', 'terrain'] as const;
export type TypeConversation = (typeof TYPES_CONVERSATION)[number];

/** Types créés par la route POST /messagerie/conversations ; les autres le sont par leur module. */
export const TYPES_CONVERSATION_CREABLES: readonly TypeConversation[] = ['interne', 'terrain'];

const identifiant = z.string().uuid('Identifiant invalide');
const contenuMessage = z.string().trim().min(1, 'Le message est vide').max(10000);

export const schemaCreationConversation = z
  .object({
    type: z.enum(TYPES_CONVERSATION),
    titre: z.string().trim().min(1).max(200),
    /** Appartenances des participants (agents de la même collectivité). */
    participants: z.array(identifiant).max(100).default([]),
    /** Conversation de service : les titulaires de poste et le responsable du service sont ajoutés. */
    service_id: identifiant.optional(),
    objet_type: z
      .string()
      .regex(/^[a-z][a-z0-9_]{1,62}$/)
      .optional(),
    objet_id: identifiant.optional(),
    message: contenuMessage.optional(),
  })
  .refine((v) => v.participants.length > 0 || v.service_id !== undefined, {
    message: 'Au moins un participant ou un service est requis',
    path: ['participants'],
  })
  .refine((v) => (v.objet_type === undefined) === (v.objet_id === undefined), {
    message: 'Le type et l\'identifiant de l\'objet vont ensemble',
    path: ['objet_id'],
  });
export type CreationConversation = z.infer<typeof schemaCreationConversation>;

export const schemaEnvoiMessage = z.object({
  contenu: contenuMessage,
  /** Documents existants de la collectivité, accessibles à tous les participants. */
  pieces: z.array(identifiant).max(10).default([]),
});

export const schemaFiltreConversations = z.object({
  q: z.string().trim().min(1).max(200).optional(),
  archivees: z.enum(['oui', 'non']).default('non'),
  non_lues: z.enum(['oui', 'non']).default('non'),
  limite: z.coerce.number().int().min(1).max(100).default(50),
});

export const schemaFiltreMessages = z.object({
  avant: schemaDateHeure.optional(),
  limite: z.coerce.number().int().min(1).max(200).default(50),
});

export const schemaRechercheMessages = z.object({
  q: z.string().trim().min(2, 'Deux caractères au moins').max(200),
  limite: z.coerce.number().int().min(1).max(100).default(50),
});

export const schemaConversationInterCollectivites = z.object({
  collectivite_id: identifiant,
  titre: z.string().trim().min(1).max(200),
  objet_type: z.string().regex(/^[a-z][a-z0-9_]{1,62}$/),
  objet_id: identifiant,
});

/** Événements du flux SSE GET /evenements. */
export const TYPES_EVENEMENT_FLUX = ['compteurs', 'message', 'notification', 'lecture', 'battement'] as const;
export type TypeEvenementFlux = (typeof TYPES_EVENEMENT_FLUX)[number];

export interface CompteursNonLus {
  messages_non_lus: number;
  conversations_non_lues: number;
  notifications_non_lues: number;
}
